export default "__VITE_ASSET__07f2c90a__"